import { env } from "configs/EnvironmentConfig";
import fetch from "../auth/FetchInterceptor";

const PaymentMethodManagerService = {};

// List User
PaymentMethodManagerService.listPaymentMethodManager = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  return fetch({
    url: `${env.API_MSP}/payment-methods?filter[record_status]=O`,
    method: "get",
    params: {
      ...columnFilter,
      // page: params.page || 1,
      // "per-page": params.sizePerPage || 10,
      // sort: params.sort || "-maker_date",
      // keywords: params.keywords || "",
      // expand: params.expand || "usprofile,checker",
    },
  });
};

// List User Role
PaymentMethodManagerService.listUserRole = ({ params }) => {
  return fetch({
    url: `${env.API_MSP}/users/default-roles`,
    method: "get",
    params: { ...params },
  });
};

// Create User
PaymentMethodManagerService.createPaymentMethodManager = ({ userCreate }) => {
  return fetch({
    url: `${env.API_MSP}/payment-methods`,
    method: "post",
    data: {
      ...userCreate,
    },
  });
};
// Update
PaymentMethodManagerService.updatePaymentMethodManager = ({ userId, data }) => {
  return fetch({
    url: `${env.API_MSP}/payment-methods/${userId}`,
    method: "put",
    data: {
      ...data,
    },
  });
};

// Detail User
PaymentMethodManagerService.detailPaymentMethodManager = function ({ userId, params }) {
  return fetch({
    url: `${env.API_MSP}/payment-methods/${userId}`,
    method: "get",
    params: {
      ...params,
      expand: params.expand || "usprofile",
    },
  });
};

// Update User
PaymentMethodManagerService.updateUser = ({ userId, data }) => {
  return fetch({
    url: `${env.API_MSP}/users/${userId}`,
    method: "put",
    data: {
      ...data,
    },
  });
};

// Delete User
PaymentMethodManagerService.deletePaymentMethodManager = ({ userId }) => {
  return fetch({
    url: `${env.API_MSP}/payment-methods/${userId.userId}`,
    method: "delete",
  });
};

// Active User
PaymentMethodManagerService.activeUser = ({ userId, data }) => {
  return fetch({
    url: `${env.API_MSP}/users/${userId}/restore`,
    method: "put",
    data: {
      ...data,
    },
  });
};

export default PaymentMethodManagerService;
